import { Injectable } from "@angular/core";
import { AngularFirestore, DocumentData, DocumentReference, QueryDocumentSnapshot } from "@angular/fire/firestore";
import { Checkin } from "src/app/models/checkin";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PathApi } from "../../paths/path-api";
import firebase from 'firebase/app';
import { Group } from "../../models/group";
import { DbAttendeesProvider } from "./db-attendees";
import { take } from "rxjs/operators";
import { TypeModule } from '../../enums/type-module';

@Injectable({
    providedIn: "root",
})
export class DbCheckinProvider {
    public headers;
    public requestOptions;
    constructor(
        private aFirestore: AngularFirestore,
        private http: HttpClient,
        private dbAttendee: DbAttendeesProvider
    ) {
        this.headers = new Headers();
        this.headers.append("Accept", "application/json");
        this.headers.append("Content-Type", "application/json");
        this.requestOptions = { headers: this.headers };
    }

    getModuleSnapshot(eventId: string) {
        return new Promise<QueryDocumentSnapshot<DocumentData>>((resolve, reject) => {
            this.aFirestore.firestore
                .collection(`events/${eventId}/modules`)
                .where('type', '==', TypeModule.CHECKIN)
                .get()
                .then(snap => (snap.docs.length == 0) ?
                    reject() : resolve(snap.docs[0])
                ).catch(err => reject(err))
        })
    }

    getCheckinList(moduleId: string, onResolve) {
        let db = this.aFirestore.firestore;

        db.collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .orderBy("order", "asc")
            .onSnapshot((values) => {
                let checkins = [];
                if (values.size >= 1) {
                    values.forEach((element) => {
                        checkins.push(element.data());
                    });
                }
                onResolve(checkins);
            });
    }

    getCheckin(moduleId: string, checkinId: string, onResolve) {
        let db = this.aFirestore.firestore;

        db.collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId)
            .get()
            .then((value) => {
                onResolve(value.data());
            });
    }

    getCheckinPromise(moduleId: string, checkinId: string) {
        return new Promise((resolve) => {
            let db = this.aFirestore.firestore;

            db.collection("modules")
                .doc(moduleId)
                .collection("checkins")
                .doc(checkinId)
                .get()
                .then((value) => {
                    resolve(value.data());
                });
        });
    }

    newCheckin(moduleId: string, eventId: string, checkin: Checkin) {
        // const body = {
        //     moduleId: moduleId,
        //     eventId: eventId,
        //     checkin: checkin,
        // };
        // // status["result"]
        // return new Promise<boolean>((res, rej) => {
        //     this.http.post(
        //         PathApi.baseUrl + PathApi.dbCheckinCreate,
        //         body,
        //         this.requestOptions
        //     ).toPromise().then((response) => {
        //         if (response["code"] == 200) res(true);
        //         else rej();
        //     }).catch(err => rej(err));
        // })

        // const ref1 = this.aFirestore.firestore.collection(
        //     `events/${eventId}/modules/${moduleId}/checkins`
        // ).doc();

        // const ref2 = this.aFirestore.firestore.collection(
        //     `modules/${moduleId}/checkins`
        // );
        let ref: DocumentReference;
        if (!checkin.uid) {
            ref = this.aFirestore.firestore.collection(
                `modules/${moduleId}/checkins`
            ).doc();
            checkin.uid = ref.id;
        } else {
            ref = this.aFirestore.firestore.doc(
                `modules/${moduleId}/checkins/${checkin.uid}`
            );
        }

        return new Promise<Checkin>((res, rej) => {
            ref.set(Object.assign({}, checkin))
                .then(() => res(checkin))
                .catch(err => rej(err))
        });
    }

    editCheckin(
        moduleId: string,
        checkinId: string,
        name: string,
        typeVisionListing,
        typeVisionViewer,
        groups,
        viewerGroups,
        onResolve
    ) {
        let db = this.aFirestore.firestore;
        let ref = db
            .collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId);

        ref.update({
            name: name,
            typeVisionListing: typeVisionListing,
            typeVisionViewer: typeVisionViewer,
            groups: groups,
            viewerGroups: viewerGroups
        })
            .then((status) => {
                onResolve(true);
            })
            .catch((err) => {
                onResolve(false);
            });
    }

    /**
     *Delete checkin. Activate the trigger:dbCheckinDelete
     *@param moduleId
     *@param checkinId
     *@returns onResolve
     */
    deleteCheckin(moduleId: string, checkinId: string, onResolve) {
        let db = this.aFirestore.firestore;
        let ref = db
            .collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId);

        ref.delete()
            .then((_) => {
                this.reorderCheckins(moduleId, (_) => {
                    onResolve(true);
                });
            })
            .catch((err) => {
                console.error(err);
                onResolve(false);
            });
    }

    /**
     *Delete checkins. Activate the trigger:dbCheckinDelete
     *@param moduleId
     *@param listCheckinsId
     *@returns onResolve
     */

    deleteCheckins(moduleId: string, listCheckinsId: Array<string>, onResolve) {
        let db = this.aFirestore.firestore;
        let batch = db.batch();

        for (const checkinId of listCheckinsId) {
            let ref = db
                .collection("modules")
                .doc(moduleId)
                .collection("checkins")
                .doc(checkinId);
            batch.delete(ref);
        }

        batch
            .commit()
            .then((_) => {
                this.reorderCheckins(moduleId, (_) => {
                    onResolve(true);
                });
            })
            .catch((err) => {
                console.error(err);
                onResolve(false);
            });
    }

    /**
     *Sorts the order field of module check ins.
     *@param moduleId
     *@returns onResolve
     */
    reorderCheckins(moduleId: string, onResolve) {
        let db = this.aFirestore.firestore;
        let ref = db
            .collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .orderBy("order", "asc");

        ref.get().then((snapshot) => {
            let order = 0;

            snapshot.forEach((element) => {
                const checkin = element.data();
                const checkinId = checkin.uid;

                db.collection("modules")
                    .doc(moduleId)
                    .collection("checkins")
                    .doc(checkinId)
                    .update({ order });
                order++;
            });

            onResolve(true);
        });
    }

    changeVisibility(moduleId: string, uid: string, status: boolean) {
        let db = this.aFirestore.firestore;
        let ref = db
            .collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(uid);

        ref.update({ visibility: status });
    }

    changeUserCheckin(eventId: string, attendee) {
        const batch = this.aFirestore.firestore.batch();
        const ref1 = this.aFirestore.doc(`events/${eventId}/attendees/${attendee.uid}`).ref;
        const ref2 = this.aFirestore.doc(`modules/${attendee.moduleId}/attendees/${attendee.uid}`).ref;

        batch.update(ref1, { checkinStatus: attendee.checkinStatus });
        batch.update(ref2, { checkinStatus: attendee.checkinStatus });

        return batch.commit();
    }

    // getAttendeesWithCheckin(
    //     eventId,
    //     moduleId,
    //     checkinId: string,
    //     order: string,
    //     typeVision: number,
    //     groups: any,
    //     onResolve
    // ) {
    //     let body = {
    //         eventId: eventId,
    //         moduleId: moduleId,
    //         checkinId: checkinId,
    //         order: order,
    //         typeVision: typeVision,
    //         groups: groups,
    //     };

    //     this.http
    //         .post(
    //             PathApi.baseUrl + PathApi.dbCheckinAttendeeCheckinStatus,
    //             body,
    //             this.requestOptions
    //         )
    //         .subscribe((aux) => {
    //             onResolve(aux["result"]);
    //         });
    // }

    getAttendeesWithCheckin(
        eventId,
        moduleId,
        checkinId: string,
        order: string,
        typeVision: number,
        groups: any,
        onResolve
    ) {
        const body = {
            eventId: eventId,
            moduleId: moduleId,
            checkinId: checkinId,
            order: order,
            typeVision: typeVision,
            groups: groups,
        };

        this.http.post(
            PathApi.baseUrl + PathApi.dbCheckinGetAttendees,
            body,
            this.requestOptions
        ).toPromise()
        .then(r => onResolve(r["result"]))
        .catch(err => console.error(err));
    }

    getCheckinModule(moduleId: string, onResolve) {
        let db = this.aFirestore.firestore;

        db.collection("modules")
            .doc(moduleId)
            .onSnapshot((snapshot) => {
                onResolve(snapshot.data());
            });
    }

    allowGroupsToModule(moduleId: string, groups: Array<Group>) {
        let db = this.aFirestore.firestore;

        for (let group of groups) {
            db.collection("modules")
                .doc(moduleId)
                .update({
                    access_group: firebase.firestore.FieldValue.arrayUnion(
                        group.uid
                    ),
                });
        }
    }

    removeGroupsFromModule(moduleId: string, group: Group) {
        let db = this.aFirestore.firestore;
        db.collection("modules")
            .doc(moduleId)
            .update({
                access_group: firebase.firestore.FieldValue.arrayRemove(
                    group.uid
                ),
            });
    }

    exportCheckin(
        eventId: string,
        moduleId: string,
        checkinId: string,
        typeVision: number,
        groups: Array<any>,
        onResolve
    ) {
        let body = {
            eventId: eventId,
            moduleId: moduleId,
            checkinId: checkinId,
            typeVision: typeVision,
            groups: groups,
        };
        this.http
            .post(
                PathApi.baseUrl + PathApi.dbAttendeesExportCheckin,
                body,
                this.requestOptions
            )
            .subscribe((snapshot) => {
                onResolve(snapshot["result"]);
            });
    }

    reorderCheckinList(moduleId: string, checkinList: Array<any>) {
        return new Promise((resolve, reject) => {
            let db = this.aFirestore.firestore;
            let cont = 0;
            let size = checkinList.length;
            checkinList.forEach((el) => {
                let checkin = el;
                db.collection("modules")
                    .doc(moduleId)
                    .collection("checkins")
                    .doc(checkin.uid)
                    .update(checkin)
                    .then((_) => {
                        cont++;
                        if (cont == size) {
                            resolve(true);
                        }
                    })
                    .catch((error) => {
                        error++;
                        if (error == size) {
                            reject(false);
                        }
                    });
            });
        });
    }

    changeAttendeeOrderInCheckin(
        moduleId: string,
        checkinId: string,
        typeOrder: string
    ) {
        let db = this.aFirestore.firestore;
        return db
            .collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId)
            .update({ typeOrder: typeOrder });
    }

    updateCheckinModule(eventId: string, moduleId: string, module: Checkin) {
        return Promise.all([
            this.aFirestore.firestore.doc(`events/${eventId}/modules/${moduleId}`).update(module),
            this.aFirestore.firestore.doc(`modules/${moduleId}`).update(module)
        ]);
    }

    editCheckinConfigs(
        moduleId: string,
        checkinId: string,
        checkin,
        onResolve
    ) {
        let db = this.aFirestore.firestore;
        let obj = {
            title: checkin["title"],
            text: checkin["text"],
            totalBgColor: checkin["totalBgColor"],
            totalTxtColor: checkin["totalTxtColor"],
            totalPresentBgColor: checkin["totalPresentBgColor"],
            totalPresentTxtColor: checkin["totalPresentTxtColor"],
            allowFooter: checkin["allowFooter"],
            allowUsername: checkin["allowUsername"],
        };

        db.collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId)
            .update(obj)
            .then((_) => {
                onResolve(true);
            })
            .catch((e) => {
                onResolve(false);
            });
    }

    getLastCheckins(moduleId: string, checkinId: string, onResolve) {
        let db = this.aFirestore.firestore;
        db.collection("modules")
            .doc(moduleId)
            .collection("checkins")
            .doc(checkinId)
            .collection("attendees")
            .where("status", "==", true)
            .orderBy("time", "desc")
            .onSnapshot((values) => {
                let users = [];
                if (values.size >= 1) {
                    values.forEach((element) => {
                        let checkin = element.data();
                        this.dbAttendee.getAttendee(
                            checkin.eventId,
                            checkin.attendeeModule,
                            checkin.uid,
                            (data) => {
                                data["result"].checkinTime = checkin.time;
                                users.push(data["result"]);
                                onResolve(users);
                            }
                        );
                    });
                } else {
                    onResolve(users);
                }
            });
    }    getEventTotalAttendeesNumber(eventId: string, onResolve) {
        let db = this.aFirestore.firestore;
        db.collection("events")
            .doc(eventId)
            .collection("attendees")
            .onSnapshot((values) => {
                onResolve(values.size);
            });
    }

    /**
     * @description get all checkIns data (i.e. firebase firestore DocumentData) and the data related to
     * the attendees listed in those check ins. The content of the response is available by accessing the
     * properties (that are Objects too) ".attendees" and ".checkins" of the returned Object in the promise
     * @param moduleId
     */
      public getCheckinStatuses(moduleId: string): Promise<any> {
        // const body = { moduleId: moduleId };
        // const post$ = this.http.post(
        //     PathApi.baseUrl + PathApi.dbCheckinStatuses,
        //     body,
        //     this.requestOptions
        // ).pipe(take(1));

        // return new Promise((response, reject) => {
        //     post$.subscribe((data) => {
        //         if (data['code'] != 200) {
        //             reject(data['message'])
        //         }
        //         else {
        //             response(data);
        //         }
        //     })
        // })
        return new Promise((resolve, reject) => {
            this.aFirestore.firestore.collection("modules").doc(moduleId).collection("checkins").get()
                .then((snapshot) => {
                    const result = { checkins: [], attendees: {} };
                    const attendeesPromises = {};

                    snapshot.forEach((doc) => {
                        const checkinData: any = { uid: doc.id, ...doc.data() };
                        result.checkins.push(checkinData);
                        const eventId = checkinData.eventId;

                        attendeesPromises[checkinData.uid] = new Promise((resolveAttendees) => {
                            const body = {
                                eventId: eventId,
                                moduleId: moduleId,
                                checkinId: checkinData.uid,
                                order: checkinData.typeOrder || "asc",
                                typeVision: checkinData.typeVisionListing || 0,
                                groups: checkinData.groups || {}
                            };

                            this.http.post(
                                PathApi.baseUrl + PathApi.dbCheckinGetAttendees,
                                body,
                                this.requestOptions
                            ).toPromise()
                            .then(r => resolveAttendees(r["result"]))
                            .catch(err => {
                                console.error(err);
                                resolveAttendees([]);
                            });
                        });
                    });

                    if (result.checkins.length === 0) {
                        return resolve(result);
                    }
                    Promise.all(Object.values(attendeesPromises))
                        .then((attendeesResults) => {
                            Object.keys(attendeesPromises).forEach((checkinId, index) => {
                                result.attendees[checkinId] = attendeesResults[index];
                            });
                            resolve(result);
                        })
                        .catch(error => reject(error));
                })
                .catch(error => reject(error));
        });
    }
}
